<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <img
      :src="logoUrl()"
      alt="Logo aplikasi"
      class="sidebar-logo"
      style="height: auto; padding: 12px 16px"
    />

    <CSidebarBrand>
      <CIcon
        custom-class-name="sidebar-brand-full"
        :icon="logoNegative"
        :height="35"
      />
      <CIcon
        custom-class-name="sidebar-brand-narrow"
        :icon="sygnet"
        :height="35"
      />
    </CSidebarBrand>
    <div class="menu-cari">
      <CIcon icon="cil-magnifying-glass" class="menu-cari-ikon" />
      <input
        v-model="cari"
        type="search"
        class="form-control form-control-sm"
        placeholder="Cari menu..."
        aria-label="Cari menu"
        @keydown.enter.prevent="bukaHasilPertama"
        @keydown.esc="cari = ''"
      />
    </div>
    <div ref="isiMenu" class="sidebar-content" style="overflow-y: auto; height: 100%">
      <AppSidebarNavAdmin v-show="role_id === '1'" :cari="cari" />
      <AppSidebarNav v-show="role_id === '2'" role="2" :cari="cari" />
      <AppSidebarNav v-show="role_id === '3'" role="3" :cari="cari" />
      <AppSidebarNav v-if="role_id === '4'" role="4" :items="navKaryawan" :cari="cari" />
      <AppSidebarNav v-if="role_id === '5'" role="5" :items="navPos" :cari="cari" />
      <AppSidebarNav v-if="role_id === '6' || role_id === '7'" :role="role_id" :items="navKlinik" :cari="cari" />
      <AppSidebarNav v-if="role_id === '8' || role_id === '9'" :role="role_id" :items="navPajak" :cari="cari" />
      <AppSidebarNav v-if="role_id === '10'" role="10" :items="navKafe" :cari="cari" />
      <div v-if="cari && tidakAdaHasil" class="small text-white-50 px-3 py-2">Menu "{{ cari }}" tidak ditemukan.</div>
    </div>
    <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleUnfoldable')"
    />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { AppSidebarNavAdmin } from './AppSidebarNavAdmin'
import navKaryawan from '@/_navKaryawan.js'
import navPos from '@/_navPos.js'
import navKlinik from '@/_navKlinik.js'
import navPajak from '@/_navPajak.js'
import navKafe from '@/_navKafe.js'
import { logoUrl } from '@/utils/branding'
import { logoNegative } from '@/assets/brand/PPI-ID-Food.png'
import { sygnet } from '@/assets/brand/PPI-ID-Food.png'
export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
    AppSidebarNavAdmin,
  },
  data() {
    return {

      role_id: localStorage.getItem('role_id'),
      navKaryawan,
      navPos,
      navKlinik,
      navPajak,
      navKafe,
      cari: '',
      tidakAdaHasil: false,
    }
  },
  watch: {
    cari() {
      this.$nextTick(() => (this.tidakAdaHasil = !this.tautanTampil().length))
    },
    // Setelah pindah halaman, pencarian dikosongkan agar menu kembali lengkap
    $route() {
      this.cari = ''
    },
  },
  methods: {
    logoUrl,
    // Tautan menu yang sedang terlihat (menu role lain disembunyikan dengan v-show)
    tautanTampil() {
      return [...this.$refs.isiMenu.querySelectorAll('a.nav-link[href]')].filter((a) => a.offsetParent !== null)
    },
    bukaHasilPertama() {
      const a = this.tautanTampil()[0]
      if (a) a.click()
    },
  },
  setup() {
    const store = useStore()
    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
}
</script>
